import { App } from "./App";
import { cartService } from "@shop/frontend/web/js/services/CartService";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { EventView } from '@frontend/src/js/views/EventView.js';

const eventView = new EventView();
eventView.showChildTicketInfo();

window.CartService = cartService;

const app = new App();

translator.getLanguages().then(() => {
	app.init({
		CartService: window.CartService,
	});
});
